import USDC from 'assets/images/tokens/usdc.svg'
import USDT from 'assets/images/tokens/usdt.svg'
import TUSD from 'assets/images/tokens/tusd.svg'

export const getTokenImage = (symbol: string) => {
  switch (symbol) {
    case 'USDC':
      return USDC
    case 'USDT':
      return USDT
    case 'TUSD':
      return TUSD
    default:
      return
  }
}
